export default __webpack_public_path__ + "static/media/A-Ha-Take-On-Me.c409165e.mp3";